import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tinymedic-patient-order-file.reducer';

export const TinymedicPatientOrderFileDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tinymedicPatientOrderFileEntity = useAppSelector(state => state.tinymedicPatientOrderFile.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tinymedicPatientOrderFileDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrderFile.detail.title">TinymedicPatientOrderFile</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrderFile.id">Id</Translate>
            </span>
          </dt>
          <dd>{tinymedicPatientOrderFileEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrderFile.name">Name</Translate>
            </span>
          </dt>
          <dd>{tinymedicPatientOrderFileEntity.name}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrderFile.active">Active</Translate>
            </span>
          </dt>
          <dd>{tinymedicPatientOrderFileEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrderFile.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{tinymedicPatientOrderFileEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrderFile.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{tinymedicPatientOrderFileEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrderFile.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{tinymedicPatientOrderFileEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrderFile.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{tinymedicPatientOrderFileEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tinymedicPatientOrderFile.tinymedicPatientOrder">Tinymedic Patient Order</Translate>
          </dt>
          <dd>{tinymedicPatientOrderFileEntity.tinymedicPatientOrder ? tinymedicPatientOrderFileEntity.tinymedicPatientOrder.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tinymedic-patient-order-file" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tinymedic-patient-order-file/${tinymedicPatientOrderFileEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TinymedicPatientOrderFileDetail;
